var _g, _g2, _g3, _g4, _path, _path2, _circle, _path3, _path4, _path5, _path6, _path7, _path8, _g5, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackgroundItems3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 285,
    height: 506,
    viewBox: "0 0 285 506",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6902_55712)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M236.25 35.6599L225.857 41.6599L223.857 38.1958L234.25 32.1958L236.25 35.6599Z",
    fill: "#208C72"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M243.713 40.5881L233.32 46.5881L231.32 43.124L241.713 37.124L243.713 40.5881Z",
    fill: "#F28520"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M250.25 59.9087L239.857 65.9087L241.857 69.3728L252.25 63.3728L250.25 59.9087Z",
    fill: "#208C72"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M249.713 50.9807L239.32 56.9807L241.32 60.4448L251.713 54.4448L249.713 50.9807Z",
    fill: "#F28520"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M229.457 47.8954L222.857 36.4639L219.393 38.4639L226.393 50.5882L227.56 51.5069L235.509 53.8459L237.073 53.6593L244.842 49.1739L249.713 50.9805L256.713 63.1049L260.177 61.1049L252.857 48.4255L251.953 47.605L245.562 45.1068L243.734 45.1952L235.816 49.7666L229.457 47.8954Z",
    fill: "#1E3966"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M243.393 40.0332L236.713 28.4639L240.177 26.4639L247.177 38.5882L247.436 39.7812L246.724 47.1202L245.734 48.6593L237.816 53.2307L235.857 58.9805L242.857 71.1049L239.393 73.1049L231.993 60.2877L231.781 58.8173L234.129 51.4569L235.073 50.1952L242.842 45.7098L243.393 40.0332Z",
    fill: "#1E3966"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_6902_55712)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.448 421.044L209.439 419.702L210.781 414.693L236.184 400.026L241.193 401.368L239.851 406.377L267.351 454.009C270.389 459.27 268.586 465.997 263.325 469.035L256.974 472.702C251.713 475.739 244.985 473.936 241.948 468.675L214.448 421.044ZM220.798 417.377L224.465 423.728L226.298 426.903L248.298 465.009C249.311 466.762 251.553 467.363 253.307 466.351L259.658 462.684C261.412 461.672 262.013 459.429 261 457.675L239 419.57L237.167 416.395L233.5 410.044L220.798 417.377Z",
    fill: "#1E3966"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M234.303 437.101L243.829 431.601L259.412 458.592C259.919 459.469 259.618 460.59 258.741 461.096L252.39 464.763C251.514 465.269 250.392 464.969 249.886 464.092L234.303 437.101Z",
    fill: "#F28520"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.044 435.711L182.693 439.377L210.193 487.009C213.231 492.27 219.958 494.072 225.22 491.035L231.57 487.368C236.832 484.331 238.634 477.603 235.597 472.342L208.097 424.711L201.746 428.377L205.413 434.728L207.246 437.903L229.246 476.009C230.258 477.762 229.658 480.005 227.904 481.017L221.553 484.684C219.799 485.697 217.557 485.096 216.544 483.342L194.544 445.237L192.711 442.061L189.044 435.711Z",
    fill: "#1E3966"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M208.049 464.96L217.575 459.46L227.658 476.925C228.165 477.802 227.864 478.923 226.987 479.43L220.637 483.096C219.76 483.603 218.638 483.302 218.132 482.425L208.049 464.96Z",
    fill: "#208C72"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_6902_55712)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.547 281.262L183.523 277.619L197.38 269.619L201.022 270.595L201.19 270.886C197.798 274.212 196.942 279.528 199.428 283.832C201.913 288.137 206.945 290.054 211.521 288.779L211.689 289.07L210.713 292.713L196.857 300.713L193.214 299.737L182.547 281.262Z",
    fill: "#1E3966"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.166 299.38C199.873 300.605 201.038 301.498 202.404 301.865C203.771 302.231 205.227 302.039 206.452 301.332C207.676 300.624 208.57 299.46 208.936 298.093C209.303 296.727 209.111 295.271 208.404 294.046L203.785 296.713L199.166 299.38Z",
    fill: "#3360AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.284 275.833C214.757 278.383 213.883 281.645 211.332 283.118C208.781 284.591 205.519 283.717 204.047 281.166C202.574 278.615 203.448 275.353 205.999 273.88C208.55 272.408 211.811 273.282 213.284 275.833Z",
    fill: "#1E3966"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M223.877 283.513L218.475 282.691C219.179 281.04 219.463 279.224 219.28 277.418L225.947 278.434L227.855 279.737L238.522 298.212L238.788 300.235L235.86 311.164L234.618 312.783L216.142 323.45L212.142 316.521L205.214 320.521L202.548 315.903L221.023 305.236L223.689 309.855L216.761 313.855L218.094 316.164L230.994 308.716L233.351 299.922L223.877 283.513Z",
    fill: "#1E3966"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210.451,
    cy: 308.26,
    r: 2.66667,
    transform: "rotate(-30 210.451 308.26)",
    fill: "#F28520"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_6902_55712)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.6025 238.515L111.535 230.393L119.934 235.243L119.404 250.525L98.6025 238.515Z",
    fill: "#3360AD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.818 226.241L115.236 224.735L121.986 213.044L129.78 217.544L123.03 229.235L122.435 231.216L121.063 254.08L94.7029 238.862L113.818 226.241ZM133.677 219.794L126.927 231.485L125.555 254.35C125.354 257.689 121.71 259.65 118.813 257.978L92.4529 242.759C89.5559 241.086 89.4318 236.949 92.2235 235.106L111.339 222.485L118.089 210.794L118.088 210.794L117.265 207.721L120.338 206.897L124.236 209.147L132.03 213.647L135.927 215.897L136.751 218.97L133.677 219.794L133.677 219.794Z",
    fill: "#1E3966"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.8562 185.909C34.513 188.779 33.5298 192.448 30.66 194.105C27.7903 195.762 24.1207 194.779 22.4639 191.909C20.807 189.039 21.7903 185.37 24.66 183.713C27.5298 182.056 31.1993 183.039 32.8562 185.909Z",
    fill: "#208C72"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1052 171.909C58.762 174.779 57.7788 178.448 54.909 180.105C52.0393 181.762 48.3697 180.779 46.7129 177.909C45.056 175.039 46.0393 171.37 48.909 169.713C51.7788 168.056 55.4483 169.039 57.1052 171.909Z",
    fill: "#208C72"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34.7844,
    cy: 173.249,
    r: 4,
    transform: "rotate(-30 34.7844 173.249)",
    fill: "#F28520"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.4213 178.077C42.6308 178.702 42.9056 179.316 43.2481 179.909C43.5905 180.502 43.9846 181.047 44.4213 181.541L37.1465 185.741C36.937 185.116 36.6622 184.502 36.3197 183.909C35.9773 183.316 35.5832 182.771 35.1465 182.277L42.4213 178.077Z",
    fill: "#1E3966"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2485 153.928C29.3531 155.841 28.6976 158.288 26.7844 159.392C24.8712 160.497 22.4249 159.841 21.3203 157.928C20.2157 156.015 20.8712 153.569 22.7844 152.464C24.6976 151.36 27.1439 152.015 28.2485 153.928Z",
    fill: "#208C72"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2828 161.737C24.5766 162.072 25.9822 161.977 27.2677 161.39L28.8009 178.974C27.483 178.821 26.1276 178.929 24.8158 179.319L23.2828 161.737Z",
    fill: "#1E3966"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.2727 160.81L42.7336 170.93C43.2605 169.712 44.0318 168.592 45.0256 167.651L30.5657 157.533C30.2084 158.821 29.4233 159.99 28.2727 160.81Z",
    fill: "#1E3966"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M201.594 130.027L199.642 137.313L207.37 139.383L211.989 136.717L216.251 128.098L206.656 127.479L201.594 130.027Z",
    fill: "#208C72"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.683 136.869L185.367 137.331L176.239 144.351L175.289 145.774L171.74 159.021L171.851 160.729L176.246 171.372L178.02 172.93L200.559 178.969L202.874 178.508L212.002 171.488L212.952 170.064L216.502 156.817L216.391 155.109L211.996 144.466L210.221 142.908L187.683 136.869ZM193.03 171.431L200.667 173.477L208.035 167.811L211.117 156.31L207.569 147.719L199.932 145.673L193.084 151.485L190.006 162.973L193.03 171.431Z",
    fill: "#EA1763"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_6902_55712)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.765 339.56L127.404 339.176L115.084 350.758L116.98 355.5L99.2558 346.503L105.716 360.863L96.926 369.653C94.13 369.09 91.5902 367.679 89.6603 365.586C87.2819 363.006 86.0057 359.58 86.0872 355.995C86.1688 352.41 87.6022 348.93 90.1002 346.252C92.5982 343.575 95.9763 341.898 99.5574 341.557C99.8979 337.976 101.575 334.598 104.252 332.1C106.93 329.602 110.41 328.169 113.995 328.087C117.58 328.006 121.006 329.282 123.586 331.66C125.836 333.735 127.298 336.515 127.765 339.56ZM127.917 342.354L118.235 351.456L122.084 361.081L104.788 352.302L108.902 361.448L100.435 369.915L127.34 369.34L127.917 342.354Z",
    fill: "#EA1763"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9807 33.5876V30.0521L67.7484 28.2843L74.8195 35.3554L71.284 38.8909L65.9807 33.5876Z",
    fill: "#208C72"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2832 24.7498L73.051 22.982L76.5865 22.982L81.8898 28.2853L78.3543 31.8208L71.2832 24.7498Z",
    fill: "#208C72"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0332 56.5669L99.5687 53.0314L104.872 58.3347L101.337 61.8702L96.0332 56.5669Z",
    fill: "#1E3966"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.0521 40.6605L73.0521 47.7316L78.3554 53.0349C73.4739 48.1533 73.4739 40.2388 78.3554 35.3572C83.237 30.4757 91.1515 30.4757 96.0331 35.3572L90.7298 30.0539L83.6587 30.0539L78.3554 35.3572L73.0521 40.6605Z",
    fill: "#1E3966"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.4976 49.4993C95.4265 46.5704 95.4265 41.8217 92.4976 38.8927C89.5686 35.9638 84.8199 35.9638 81.891 38.8927C78.962 41.8217 78.962 46.5704 81.891 49.4993C84.8199 52.4283 89.5686 52.4283 92.4976 49.4993ZM96.0331 53.0349C100.915 48.1533 100.915 40.2388 96.0331 35.3572C91.1515 30.4757 83.237 30.4757 78.3554 35.3572C73.4739 40.2388 73.4739 48.1533 78.3554 53.0349C83.237 57.9164 91.1515 57.9164 96.0331 53.0349Z",
    fill: "#1E3966"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8926 42.4265L85.4281 38.891L92.4992 45.962L88.9636 49.4976L81.8926 42.4265Z",
    fill: "#3360AD"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6902_55712"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(207 41) rotate(-30)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_6902_55712"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 88,
    fill: "white",
    transform: "translate(164 429) rotate(-30)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_6902_55712"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(167 281) rotate(-30)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_6902_55712"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    fill: "white",
    transform: "translate(107 194) rotate(30)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_6902_55712"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(67 354.255) rotate(-45)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundItems3);
export default __webpack_public_path__ + "static/media/background-items-3.0cb8c9340a31cc5058f9b6498ba3e207.svg";
export { ForwardRef as ReactComponent };